// extracted by mini-css-extract-plugin
module.exports = {"header":"About_header__3g_pL","buttons":"About_buttons__3Y8oU","infoLbl":"About_infoLbl__2fbVM","creatorHdr":"About_creatorHdr__P9Oln"};